(function(){"use strict";

// --- CART: DNI/NIF ---
if(window.location.pathname==="/cart"){var enforceDNI=function(){var inp=document.querySelector('[name="attributes[DNI/NIF]"]');if(!(!inp||inp.required)){inp.required=!0,inp.setAttribute("required","required");var form=inp.closest("form");form&&!form.dataset.dniGuard&&(form.dataset.dniGuard="1",form.addEventListener("submit",function(e){if(!inp.value.trim()){e.preventDefault(),inp.focus(),inp.style.outline="2px solid red";var msg=document.getElementById("dni-err");msg||(msg=document.createElement("p"),msg.id="dni-err",msg.style.color="red",msg.style.fontSize="13px",msg.style.marginTop="4px",msg.textContent="El DNI/NIF es obligatorio para emitir factura.",inp.parentNode.insertBefore(msg,inp.nextSibling))}}),inp.addEventListener("input",function(){inp.style.outline="";var m=document.getElementById("dni-err");m&&m.remove()}))}};enforceDNI(),setTimeout(enforceDNI,500),setTimeout(enforceDNI,1500);var obs=new MutationObserver(enforceDNI);obs.observe(document.body,{childList:!0,subtree:!0}),setTimeout(function(){obs.disconnect()},1e4);}

// --- PRODUCT: Peso aproximado ---
if(window.location.pathname.includes("/products/")){
  var PROP="Peso aproximado";

  var formatPeso=function(g){
    if(g>=1000){var k=g/1000;return"aprox. "+(k%1===0?k:parseFloat(k.toFixed(2)).toString().replace(".",","))+" kg";}
    return"aprox. "+Math.round(g)+" g";
  };

  var getPesoFromPage=function(){
    var all=document.querySelectorAll("p,li");
    for(var i=0;i<all.length;i++){var t=all[i].textContent.trim();if((t.match(/^aprox\./i)&&t.length<60)||(t.match(/^\d[\d,.]*\s*(g|kg)\b/i)&&t.length<30))return t;}
    return null;
  };

  // FIX v6: usa f.elements.namedItem() en lugar de querySelector con selector CSS
  // (el selector CSS con corchetes en el nombre causaba SyntaxError en todos los navegadores)
  var setPesoInput=function(peso){
    if(!peso)return;
    var propName="properties["+PROP+"]";
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(f){
      var ex=f.elements.namedItem(propName);
      if(ex){ex.value=peso;}
      else{var inp=document.createElement("input");inp.type="hidden";inp.name=propName;inp.value=peso;f.appendChild(inp);}
    });
  };

  var injectUnitPrice=function(variant){
    if(variant.unit_price&&variant.unit_price_measurement)return;
    if(!variant.weight||variant.weight<=0||!variant.price)return;
    var centsPerKg=Math.round(variant.price*1000/variant.weight);
    var euros=Math.floor(centsPerKg/100);var cents=centsPerKg%100;
    var priceStr=euros+","+(cents<10?"0":"")+cents;
    setTimeout(function(){
      document.querySelectorAll("product-price").forEach(function(pp){
        if(pp.querySelector("small.unit-price"))return;
        var small=document.createElement("small");small.className="unit-price";
        var span=document.createElement("span");span.className="visually-hidden";span.textContent="Precio unitario";
        small.appendChild(span);small.appendChild(document.createTextNode("\n  €"+priceStr+"/kg\n"));
        var wrapper=document.createElement("div");wrapper.appendChild(small);pp.appendChild(wrapper);
      });
    },300);
  };

  var handle=window.location.pathname.split("/products/")[1].split("?")[0].split("/")[0];
  fetch("/products/"+handle+".js")
    .then(function(r){return r.json();})
    .then(function(p){
      var vm={};(p.variants||[]).forEach(function(v){vm[v.id.toString()]=v;});
      function getVarId(){var id=new URLSearchParams(window.location.search).get("variant");return id||(p.variants&&p.variants.length?p.variants[0].id.toString():null);}
      function run(){
        var v=vm[getVarId()];
        var peso=null;
        // FIX v6: variant.weight es la fuente PRIMARIA (siempre en gramos, siempre fiable)
        // Elimina el umbral >=300 que bloqueaba productos de 200g
        if(v&&v.weight>0)peso=formatPeso(v.weight);
        // Último recurso: texto de la página
        if(!peso)peso=getPesoFromPage();
        setPesoInput(peso);
        if(v)injectUnitPrice(v);
      }
      run();
      var lastS=window.location.search;
      setInterval(function(){if(window.location.search!==lastS){lastS=window.location.search;run();}},300);
      document.addEventListener("variant:changed",run);
      document.addEventListener("theme:variant:change",run);
    })
    .catch(function(){var p=getPesoFromPage();if(p)setPesoInput(p);});
}

})();
